// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"F3-z","displaySixCardTiles":"G3-z"};